import { getNewErrorMessage } from "../../utilsv2";
import FetchService from "../../FetchService/CustomService";
import { GetTabsParams, TabsResponse } from "./types";
import { AxiosResponse } from "axios";

const BaseUrl = process.env.BASE_URL;

/**
 * Service for handling job tabs related API requests
 */
const JobTabService = {
  /**
   * Get tabs data with optional active tab parameter
   * @param params - Object containing optional activeTabId
   * @returns Promise resolving to tabs data
   */
  async getTabs({
    activeTabId = null
  }: GetTabsParams = {}): Promise<TabsResponse> {
    try {
      const url =
        BaseUrl +
        `/recruiter/job/tab-counts${
          activeTabId ? `?active_tab_id=${activeTabId}` : ""
        }`;

      const loaderConfig = { hasLoader: false };

      const response = (await FetchService.getCall({
        url,
        query: {},
        loaderConfig
      })) as AxiosResponse;

      return response?.data?.data || { tabs: [] };
    } catch (error) {
      return Promise.reject(getNewErrorMessage(error));
    }
  }
};

export default JobTabService;
